import React from "react";

const Certification = ({name, year}) => {
    return (
        <p>- {name} <span>{year}</span></p>
        );
    };
    
export default Certification;
    